
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import store from "@/store";

export default Vue.extend({
  name: "loginForm",
  mixins: [validationMixin],
  data() {
    return {
      isPasswordVisible: false,
    };
  },
  computed: {
    // mobile number validation/errors
    mobile: {
      get(): string {
        return store.state.auth.loginData.mobile;
      },
      set(value: string): void {
        store.dispatch("auth/updateMobileLogin", value);
      },
    },
    mobileError(): string[] {
      const errors: string[] = [];
      if (!this.$v.mobile?.$dirty) {
        return errors;
      }
      !this.$v.mobile.required && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.mobile.minLength &&
        errors.push("شماره موبایل باید دارای حداقل 11 رقم باشد");
      !this.$v.mobile.maxLength &&
        errors.push("شماره موبایل باید دارای حداکثر 11 رقم باشد");
      return errors;
    },
    // password validation/errors
    password: {
      get(): string {
        return store.state.auth.loginData.password;
      },
      set(value: string): void {
        store.dispatch("auth/updatePasswordLogin", value);
      },
    },
    passwordError(): string[] {
      const errors: string[] = [];
      if (!this.$v.password?.$dirty) {
        return errors;
      }
      !this.$v.password.required && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.password.minLength &&
        errors.push("پسورد باید شامل حداقل 8 کاراکتر باشد");
      return errors;
    },
    // loading
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  methods: {
    userLogin() {
      store.dispatch("auth/userLogin");
    },
  },
  validations: {
    mobile: {
      required,
      minLength: minLength(11),
      maxLength: maxLength(11),
    },
    password: {
      required,
      minLength: minLength(8),
    },
  },
});
